const mapAttachment = (attachment = {}) => ({
    id: Number(attachment.id),
    name: attachment.original_name || attachment.server_name || attachment.path || "",
    extension: attachment.extension || "",
    path: attachment.path || ""
});

const mapComment = (comment = {}) => ({
    id: Number(comment.id),
    text: comment.content || "",
    author: `${ comment?.relUser?.name || "" } ${ comment?.relUser?.surname || "" }`.trim(),
    authorId: Number(comment.user_id || comment?.relUser?.id),
    createdAt: comment.created_at,
    attachments: Array.isArray(comment.relAttachments) ? comment.relAttachments.map(mapAttachment) : []
});

const splitFileName = (fileName = "", extension = "") => {
    const trimmedName = String(fileName || "").trim();
    const normalizedExt = String(extension || "").trim().replace(/^\./, "");

    if (!trimmedName) {
        return {
            base: "",
            extension: normalizedExt ? `.${ normalizedExt }` : ""
        };
    }

    if (normalizedExt) {
        const suffix = `.${ normalizedExt }`;
        const hasSuffix = trimmedName.toLowerCase().endsWith(suffix.toLowerCase());

        return {
            base: hasSuffix ? (trimmedName.slice(0, -suffix.length) || trimmedName) : trimmedName,
            extension: suffix
        };
    }

    const dotIdx = trimmedName.lastIndexOf(".");
    if (dotIdx <= 0 || dotIdx === trimmedName.length - 1) {
        return {
            base: trimmedName,
            extension: ""
        };
    }

    return {
        base: trimmedName.slice(0, dotIdx),
        extension: trimmedName.slice(dotIdx)
    };
};

const CommentsMappers = {
    mapAttachment,
    mapComment,
    splitFileName
};

export default CommentsMappers;
